import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Compliance = () => {
  return (
    <Container className="py-5">
      <Row>
        <Col lg={8} className="mx-auto">
          <h1 className="mb-4">Regulatory Compliance</h1>
          <p className="lead">
            Airclift Capital operates under strict regulatory frameworks to
            ensure full compliance with financial regulations worldwide.
          </p>

          <div className="mt-5">
            <h3>Regulatory Framework</h3>
            <p>
              We are committed to maintaining the highest standards of
              regulatory compliance across all jurisdictions where we operate.
            </p>

            <ul className="mt-3">
              <li>FCA Regulated in the United Kingdom</li>
              <li>CFTC Compliant in the United States</li>
              <li>MiFID II Compliant for European Operations</li>
              <li>AML/KYC Procedures for All Clients</li>
              <li>GDPR Compliant Data Protection</li>
            </ul>
          </div>

          <div className="mt-5">
            <h3>Audit & Reporting</h3>
            <p>
              Regular audits by third-party firms ensure ongoing compliance with
              all applicable regulations and industry best practices.
            </p>
          </div>

          <div className="mt-5">
            <h3>Contact Compliance Team</h3>
            <p>
              For compliance-related inquiries, please contact our dedicated
              compliance team at compliance@airclift.com
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Compliance;
